export default __webpack_public_path__ + "static/media/02_ochrana-pred-zveri-min.e0ebb1bf.jpg";